import { useState, useEffect } from 'react';
import { ArrowRight } from 'lucide-react';
import { buildSignupUrl } from '../../lib/signupUrl';

const UrgencyBanner = () => {
  const [timeLeft, setTimeLeft] = useState({ hours: 23, minutes: 59, seconds: 59 });
  const signupUrl = buildSignupUrl();

  useEffect(() => {
    const getEndTime = () => {
      const stored = localStorage.getItem('adoriOfferEndTime');
      if (stored) {
        const endTime = parseInt(stored, 10);
        if (endTime > Date.now()) return endTime;
      }
      const newEndTime = Date.now() + 24 * 60 * 60 * 1000;
      localStorage.setItem('adoriOfferEndTime', newEndTime.toString());
      return newEndTime;
    };

    const endTime = getEndTime();

    const updateTimer = () => {
      const now = Date.now();
      const diff = endTime - now;
      
      if (diff <= 0) {
        localStorage.removeItem('adoriOfferEndTime');
        window.location.reload();
        return;
      }

      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      
      setTimeLeft({ hours, minutes, seconds });
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, []);

  const formatTime = (num) => num.toString().padStart(2, '0');

  return (
    <div 
      className="bg-brand-primary text-surface-base py-2.5 px-4 text-center text-sm font-semibold sticky top-0 z-[60] flex items-center justify-center gap-3 flex-wrap"
      data-testid="urgency-banner"
    >
      <span className="flex items-center gap-2">
        <span className="animate-pulse">🔥</span>
        <span>Early Adopter Offer — 50% off Pro ends in</span>
      </span>
      <div className="flex items-center gap-1 font-mono font-bold bg-black/20 px-3 py-1 rounded-full">
        <span>{formatTime(timeLeft.hours)}</span>
        <span>:</span>
        <span>{formatTime(timeLeft.minutes)}</span>
        <span>:</span>
        <span>{formatTime(timeLeft.seconds)}</span>
      </div>
      <a 
        href={signupUrl}
        className="flex items-center gap-1 hover:underline underline-offset-2"
        data-testid="urgency-banner-cta"
      >
        Claim discount <ArrowRight className="w-4 h-4" />
      </a>
    </div>
  );
};

export default UrgencyBanner;
